<ion-header>
  <ion-toolbar mode="md"
               color="dark">
    <ion-title>{{ 'payment.creditCardTransaction' | transloco }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content fullscreen>
  <div class="gateway-transaction">
    <div *ngIf="view === 'in_progress'">
      <img src="assets/image/payments/gateway-in-progress.png">
      <h1>{{ 'payment.paymentRequestInProgress' | transloco }}</h1>
      <p *ngIf="!isManualCardEntry">{{ 'payment.instructGuestFollowPrompts' | transloco }}</p>

      <!-- Display cancel button for stripe payments only -->
      <ng-container *ngIf="(creditCardProcessingType$ | async) === 'Stripe'">
        <div>
          <ion-button color="danger"
                      debounce-click
                      [debounceTime]="0"
                      (debounceClick)="onCancelTransaction()">{{ 'payment.cancelTransaction' | transloco }}</ion-button>
        </div>
      </ng-container>
    </div>
    <div *ngIf="view === 'success'">
      <img src="assets/image/payments/gateway-complete.svg">
      <h1>{{ 'payment.approved' | transloco }}</h1>
      <p>{{ 'payment.ensureCardRemovedProvideReceipt' | transloco }}</p>
      <div>
        <ion-button debounce-click
                    [debounceTime]="0"
                    (debounceClick)="modalCtrl.dismiss()"
                    color="dark">{{ 'common.close' | transloco }}</ion-button>
      </div>
    </div>
    <div *ngIf="view === 'error'">
      <img src="assets/image/payments/gateway-error.png">
      <h1>{{ 'payment.paymentNotCompleted' | transloco }}</h1>

      <ng-container *ngIf="gatewayError">
        <p *ngIf="gatewayError.cmdStatus as cmdStatus" class="ion-text-center">
          {{ 'payment.cmdStatus' | transloco }}: {{cmdStatus}}
        </p>
        <p *ngIf="gatewayError.message as textResponse" class="ion-text-center">
          {{ 'payment.textResponse' | transloco }}: {{ textResponse }}
        </p>
      </ng-container>

      <div>
        <ion-button debounce-click
                    [debounceTime]="0"
                    (debounceClick)="onRetry()"
                    color="dark">{{ 'errors.tryAgain' | transloco }}</ion-button>
        <ion-button debounce-click
                    [debounceTime]="0"
                    (debounceClick)="modalCtrl.dismiss()"
                    color="danger">{{ 'common.cancel' | transloco }}</ion-button>
      </div>
    </div>
  </div>
</ion-content>